import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "inherit",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M2.5 4.5 1 6m0 0 1.5 1.5M1 6h10M4.5 2.5 6 1m0 0 1.5 1.5M6 1v10m1.5-1.5L6 11m0 0L4.5 9.5m5-5L11 6m0 0L9.5 7.5"
    }, null, -1)
  ]))]))
}
export default { render: render }